<template>
  <div>
    <el-form-item
      class="custom-label__input width25"
      label="Danh sách lưu trú"
      prop="places"
    >
      <div class="flex-row flex__left">
        <el-button class="btnPlain" @click="addPlaces">
          <i class="fas fa-plus-circle"></i>
          Thêm điểm lưu trú
        </el-button>
      </div>
    </el-form-item>
    <div class="form-input">
      <el-table
        class="table detailRelatedDocs"
        :data="places"
        v-if="places && places.length"
      >
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-row :gutter="24">
              <el-col :span="12">
                <hc-maybay-user-route-extend-info-item
                  fieldTitle="Số lượng phòng đơn"
                  :value="`${props.row.countRoom1}`"
                ></hc-maybay-user-route-extend-info-item>
              </el-col>

              <el-col :span="12">
                <hc-maybay-user-route-extend-info-item
                  fieldTitle="Số lượng phòng đôi"
                  :value="`${props.row.countRoom2}`"
                ></hc-maybay-user-route-extend-info-item>
              </el-col>
            </el-row>
          </template>
        </el-table-column>

        <el-table-column width="40" type="index">
          <template #header
          >#
          </template>
        </el-table-column>

        <el-table-column
          label="Điểm đi"
          show-overflow-tooltip
          property="airportFrom"
        >
          <template slot-scope="scope">
            <div>
              <i class="fas fa-map-marker-alt color__blue"></i>
              <break-word-span
                :text="getPlaceLabel(scope.row)"
                :maxLength="100"
              ></break-word-span>
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="Thời gian checkin / checkout"
          show-overflow-tooltip
          property="flightTimeEstimate"
          align="left"
          width="200px"
        >
          <template slot-scope="scope">
            <div>
              <i class="fas fa-arrow-right color__blue"></i>
              <span class="font-size__small">In: </span>
              <break-word-span
                :text="getDatetimeLabel(scope.row.checkIn)"
                :maxLength="25"
              ></break-word-span>
              <br/>
              <i class="fas fa-arrow-left color__red"></i>
              <span class="font-size__small">Out: </span>
              <break-word-span
                :text="getDatetimeLabel(scope.row.checkOut)"
                :maxLength="25"
              ></break-word-span>
            </div>
          </template>
        </el-table-column>

        <el-table-column align="center" header-align="left" width="80">
          <template slot-scope="scope">
            <el-tooltip placement="top" content="Sửa">
              <i
                class="el-icon-edit font-size__large color__blue clickable"
                @click="edit(scope.row)"
              ></i>
            </el-tooltip>
            <el-tooltip placement="top" content="Xóa">
              <i
                class="el-icon-circle-close font-size__large color__red clickable"
                @click="removePlace(scope.row)"
              ></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <hc-ks-add-place-dialog
      v-if="isEnableDialogAdd"
      :isOpen="isOpenDialogAdd"
      :place="selectedPlace"
      @closeDialog="isOpenDialogAdd = false"
      @dialogClosed="isEnableDialogAdd = false"
      @submit="addPlace"
    ></hc-ks-add-place-dialog>
  </div>
</template>

<script>
  import constants from "../../../constants";
  import errorMessageFilter from "../../../filters/errorMessageFilter";
  import hanhChinhUtils from "../../../services/hanhChinhUtils";
  import hcCaseHotelLocationViewService from "../../../services/khachsan/hcCaseHotelLocationViewService";
  import hcCaseHotelPriceService from "../../../services/khachsan/hcCaseHotelPriceService";
  import utils from "../../../services/utils";
  import handleRequestErrorMixin from "../../handleRequestErrorMixin";
  import uploadFileMixin from "../../doc-in/uploadFileMixin";
  import BreakWordSpan from "../ketluan/break-word-span";
  import HcMaybayUserRouteExtendInfoItem from "../vemaybay/hc-maybay-user-route-extend-info-item";
  import HcKsAddPlaceDialog from "./hc-ks-add-place-dialog";
  import h from "../../../services/h";
  import dateFormatter from "../../../filters/dateFormatter";

  export default {
    name: "hc-ks-places",
    mixins: [handleRequestErrorMixin, uploadFileMixin],
    components: {
      HcMaybayUserRouteExtendInfoItem,
      HcKsAddPlaceDialog,
      BreakWordSpan
    },
    props: ["hcCaseMasterId"],

    data() {
      return {
        locations: [],
        hotels: [],
        places: [],
        isOpenDialogAdd: false,
        isEnableDialogAdd: false,
        selectedPlace: null
      };
    },

    watch: {
      isOpenDialogAdd(newValue) {
        if (newValue) this.isEnableDialogAdd = newValue;
        else if (this.selectedPlace) this.selectedPlace = null;
      },

      hcCaseMasterId(newValue) {
        if (newValue) this.initForEdit();
      }
    },

    created() {
      this.loadLocations();
      this.loadHotels();
      if (this.hcCaseMasterId) this.initForEdit();
    },

    methods: {
      async initForEdit() {
        let hcCaseHotelLocations = null;
        let hcCaseHotelPrices = null;
        await hcCaseHotelLocationViewService
          .findByHcCaseMaster(this.hcCaseMasterId)
          .then(response => (hcCaseHotelLocations = response.data));
        await hcCaseHotelPriceService
          .findByHcCaseMaster(this.hcCaseMasterId)
          .then(response => (hcCaseHotelPrices = response.data));
        this.places = h.collect(hcCaseHotelLocations, hcCaseHotelLocation => {
          return {
            location: hcCaseHotelLocation.locationId,
            hotel: hcCaseHotelLocation.hotelId,
            checkIn: hcCaseHotelLocation.checkIn,
            checkOut: hcCaseHotelLocation.checkOut,
            countRoom1: this.getCount(
              hcCaseHotelLocation,
              hcCaseHotelPrices,
              constants.HC_CASE_HOTEL_PRICE.ROOM_TYPE.PHONG_DON
            ),
            countRoom2: this.getCount(
              hcCaseHotelLocation,
              hcCaseHotelPrices,
              constants.HC_CASE_HOTEL_PRICE.ROOM_TYPE.PHONG_DOI
            )
          };
        });
      },

      getCount(hcCaseHotelLocation, hcCaseHotelPrices, roomType) {
        let hcCaseHotelPrice = h.find(
          hcCaseHotelPrices,
          hcCaseHotelPrice =>
            hcCaseHotelPrice.roomType === roomType &&
            hcCaseHotelPrice.locationId === hcCaseHotelLocation.id
        );
        return (hcCaseHotelPrice ? hcCaseHotelPrice.countRoom : null) || 0;
      },

      edit(place) {
        this.selectedPlace = place;
        this.isOpenDialogAdd = true;
      },

      getData() {
        return this.places;
      },

      getDatetimeLabel(time) {
        return time ? dateFormatter(time) : "-";
      },

      getPlaceLabel(place) {
        let location = h.find(this.locations, item => item.id === place.location);
        let hotel = h.find(this.hotels, item => item.id === place.hotel);
        let temp_ = [];
        if (location) temp_.push(`(${location.categoryName})`);
        if (hotel) temp_.push(hotel.categoryName);
        return temp_.join(" ");
      },

      loadLocations() {
        return hanhChinhUtils
          .loadHotelLocations()
          .then(locations => (this.locations = locations));
      },

      loadHotels() {
        return hanhChinhUtils.loadHotels().then(hotels => (this.hotels = hotels));
      },

      addPlaces() {
        this.isOpenDialogAdd = true;
      },

      addPlace(event) {
        let place = event.result;
        !this.selectedPlace
          ? this.places.push(place)
          : this.bindDataToForm(this.selectedPlace, place);
        this.isOpenDialogAdd = false;
      },

      bindDataToForm(form, place) {
        form.location = place.location;
        form.hotel = place.hotel;
        form.checkIn = place.checkIn;
        form.checkOut = place.checkOut;
        form.countRoom1 = place.countRoom1;
        form.countRoom2 = place.countRoom2;
      },

      removePlace(place) {
        return utils
          .confirm(
            this.$confirm,
            errorMessageFilter({errorCode: "hcHotel.places.deleteConfirm"})
          )
          .then(() => this.places.splice(this.places.indexOf(place), 1));
      }
    }
  };
</script>

<style scoped>
  .download-icon:hover {
    color: var(--color-blue) !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/adminstration/khachsan/hc-ks-places.vue